import { render, staticRenderFns } from "./FeaturesGrid.vue?vue&type=template&id=769f2920&scoped=true"
import script from "./FeaturesGrid.vue?vue&type=script&lang=js"
export * from "./FeaturesGrid.vue?vue&type=script&lang=js"
import style0 from "./FeaturesGrid.vue?vue&type=style&index=0&id=769f2920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f2920",
  null
  
)

export default component.exports